import { Box } from '@usap/uicomponents'
import styled from 'styled-components'

const ChatWithUsContainer = styled(Box)`
text-align: center;
align-self: center;
display: -webkit-box;
display: -webkit-flex;
display: -ms-flexbox;
display: flex;
box-sizing: border-box;
max-width: 100%;
width: 100%;
justify-content: center;
-webkit-align-items: center;
-webkit-box-align: center;
-ms-flex-align: center;
align-items: center;
min-width: 0;
min-height: 0;
-webkit-flex-direction: row;
-ms-flex-direction: row;
flex-direction: row;
margin-top: 40px;

> div {
  color: rgb(5, 98, 155);
  cursor: pointer;
  background: none;
  border: none;
  padding: 0px 5px;
  font-size: 14px;

  @media only screen and (max-width: 768px) {
    margin-top: 0px;
    margin-bottom: 0px;
  }
}
`

export default ChatWithUsContainer
